module.exports = __webpack_public_path__ + "img/iconChevronLeft.29a586f9.svg";